import { RmCard, RmCardContent } from "@/components/RmCard";
import { RmLoadingSpinner } from "@/components/RmLoadingSpinner";

export const ScreenLoading = () => {
  return (
    <div className="flex w-full items-center justify-center">
      <RmCard>
        <RmCardContent className="flex items-center justify-center">
          <RmLoadingSpinner />
        </RmCardContent>
      </RmCard>
    </div>
  );
};
